import React from 'react';
import { string } from 'prop-types';
import { category as CategoryUtil } from 'utils';
import { categoryShape, platformShape } from 'shapes';
import { useLocationSearchParams } from 'hooks';
import InCategorySearchHeaderInline from '../InCategorySearchHeaderInline';
import InCategorySearchList from '../InCategorySearchList';

const InCategorySearchSelected = ({ category, platform, query }) => {
    const [selectedFilters] = useLocationSearchParams();
    const selectedCategory = CategoryUtil.formatSelectedCategoryData({
        category,
        platform,
        query,
        selectedFilters,
    });

    return (
        <div className="intra-category__filters-wrapper">
            <div className="intra-category__controller--with-header">
                <InCategorySearchHeaderInline />
                <div>
                    <InCategorySearchList values={selectedCategory} />
                </div>
            </div>
        </div>
    );
};

InCategorySearchSelected.propTypes = {
    category: categoryShape.isRequired,
    query: string.isRequired,
    platform: platformShape.isRequired,
};

InCategorySearchSelected.displayName = 'InCategorySearchSelected';

export default InCategorySearchSelected;
